export default __webpack_public_path__ + "static/media/WhiteArrow.26339407.svg";